/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable prefer-const */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-await-in-loop */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-tabs */

import SkillMapFieldService, { SkillMapFieldItem, SkillMapFieldResponse } from "../api/SkillMapFieldService";
import SkillMapCellService, { SkillMapCellResponse } from "../api/SkillMapCellService";

export interface SkillMapFieldTree {
    fieldlevelOne: FieldlevelOne[];
}

interface Fieldlevel {
    fieldTitle: string;
    fieldId: string;
    fieldLevel: string;
    parentFieldId: string;
    cellDataNum?: number;
}

interface FieldlevelOne extends Fieldlevel {
    fieldlevelTwo: FieldlevelTwo[];
}

interface FieldlevelTwo extends Fieldlevel {
    fieldlevelThree?: FieldlevelThree[];
    cellData?: CellData[];
    cellDataNum?: number;
}

interface FieldlevelThree extends Fieldlevel {
    cellData?: CellData[];
    cellDataNum?: number;
}

interface CellData {
    fieldName1: string;
    fieldId1: string;
    fieldName2: string;
    fieldId2: string;
    fieldName3: string;
    fieldId3: string;
    levelTitle: string;
    contents: string;
    careerCount: string;
    status: string;
    statusId: string;
    cellSubCareer: CellSubCareer[];
    cmcId: string;
}

interface CellSubCareer {
    careerType: string;
    careerTypeId: string;
    careerTitle: string;
    careerId: string;
    rankName: string;
    rankId: string;
    isPriority: string;
    status: string;
    statusId: string;
    statusNum: string;
    complDate: string;
    validDate: string;
    aplType: string;
    appChangeOkFlg: boolean;
    appCancelOkFlg: boolean;
    appLectureOkFlg: boolean;
    appResultOkFlg: boolean;
    assessMentResultDispFlg: boolean;
    certificateUploadFlg: boolean;
    certificateDispFlg: boolean;
    lecCancelOkFlg: boolean;
    referenceOkFlg: boolean;
    retakeOkFlg: boolean;
    taskReportOkFlg: boolean;
    enqueteDispFlg: boolean;
    compulsoryCssClass: string;
    classId: string;
    outOfPeriodFlg: boolean;
    reasonCode: string;
    seq: string;
    testFlg: boolean;
}

const skillMapFieldService = new SkillMapFieldService();
const skillMapCellService = new SkillMapCellService();

const getSkillMapFieldTree = async (cmId: string) => {
    // 画面側から渡されたcmIdでskillMapFieldを取得
    const skillMapFieldResponse: SkillMapFieldResponse = await skillMapFieldService.postResponse({ cmId });
    const existenceFieldlevelThree = skillMapFieldResponse.fieldlevelThree || [];
    let skillMapCellResponse: SkillMapCellResponse;
    let cellDataNum: number;

    // skillMapFieldで取得したものを回し分野1の下に分野2を入れたツリーを作成
    const fieldlevelOne: FieldlevelOne[] = skillMapFieldResponse.fieldlevelOne.map((fieldOne) => {
        const one: FieldlevelOne = { ...fieldOne, fieldlevelTwo: [] };

        const two: SkillMapFieldItem[] = skillMapFieldResponse.fieldlevelTwo.filter((fieldTwo) => fieldTwo.parentFieldId === fieldOne.fieldId);
        two.forEach((item: SkillMapFieldItem) => {
            one.fieldlevelTwo.push({ ...item, fieldlevelThree: [], cellData: [] });
        });

        return one;
    });
    const skillMapFieldTree: SkillMapFieldTree = {
        fieldlevelOne,
    };

    // skillMapFieldを取得した際に分野3が存在した場合、分野2の下に分野3を入れたツリーを作成
    if (existenceFieldlevelThree.length > 0) {
        skillMapFieldResponse.fieldlevelThree.forEach((fieldlevelThree: SkillMapFieldItem) => {
            skillMapFieldTree.fieldlevelOne?.forEach((one: FieldlevelOne) => {
                one.fieldlevelTwo.forEach((two: FieldlevelTwo) => {
                    if (two.fieldId === fieldlevelThree.parentFieldId) {
                        two.fieldlevelThree!.push({ ...fieldlevelThree, cellData: [] });
                    }
                });
            });
        });
        // skillMapFieldのResponseを回し分野2のfieldIdだけを抜き出した配列を作成
        const fieldIdOnlyTwoList: string[] = skillMapFieldResponse.fieldlevelTwo.map((item: SkillMapFieldItem) => item.fieldId);
        // 分野2のfieldIdの数だけskillMapCellのAPIを実行する。そこで取得したcellDataを分野2のfieldIdとcellDataのfieldId2が一致するものを分野2の配下に収める
        for (const fieldId of fieldIdOnlyTwoList) {
            const skillMapCellRequestItems = { cmId, fieldLevel: "2", fieldId };
            skillMapCellResponse = await skillMapCellService.postResponse(skillMapCellRequestItems);

            skillMapCellResponse.cellData.forEach((cellData) => {
                skillMapFieldTree.fieldlevelOne.forEach((one: FieldlevelOne) => {
                    one.fieldlevelTwo.forEach((two: FieldlevelTwo) => {
                        if (two.fieldId === cellData.fieldId2 && !cellData.fieldId3) {
                            two.cellData!.push(cellData);
                        }
                    });
                });
            });
        }
        // skillMapFieldのResponseを回し分野3のfieldIdだけを抜き出した配列を作成
        const fieldIdOnlyThreeList: string[] = skillMapFieldResponse.fieldlevelThree.map((item: SkillMapFieldItem) => item.fieldId);
        // 分野3のfieldIdの数だけskillMapCellのAPIを実行する。そこで取得したcellDataを分野3のfieldIdとcellDataのfieldId3が一致するものを分野3の配下に収める
        for (const fieldId of fieldIdOnlyThreeList) {
            const skillMapCellRequestItems = { cmId, fieldLevel: "3", fieldId };
            skillMapCellResponse = await skillMapCellService.postResponse(skillMapCellRequestItems);

            skillMapCellResponse.cellData.forEach((cellData) => {
                skillMapFieldTree.fieldlevelOne.forEach((one: FieldlevelOne) => {
                    one.fieldlevelTwo.forEach((two: FieldlevelTwo) => {
                        two.fieldlevelThree?.forEach((three: FieldlevelThree) => {
                            if (three.fieldId === cellData.fieldId3) {
                                three.cellData!.push(cellData);
                            }
                        });
                    });
                });
            });
        }
    } else {
        const fieldIdOnlyTwoList: string[] = skillMapFieldResponse.fieldlevelTwo.map((item: SkillMapFieldItem) => item.fieldId);
        for (const fieldId of fieldIdOnlyTwoList) {
            const skillMapCellRequestItems = { cmId, fieldLevel: "2", fieldId };
            skillMapCellResponse = await skillMapCellService.postResponse(skillMapCellRequestItems);

            skillMapCellResponse.cellData.forEach((cellData) => {
                skillMapFieldTree.fieldlevelOne.forEach((one: FieldlevelOne) => {
                    one.fieldlevelTwo.forEach((two: FieldlevelTwo) => {
                        if (two.fieldId === cellData.fieldId2 && cellData.fieldId3 === null) {
                            two.cellData!.push(cellData);
                        }
                    });
                });
            });
        }
    }

    skillMapFieldTree.fieldlevelOne.forEach((one: FieldlevelOne) => {
        one.fieldlevelTwo.forEach((two: FieldlevelTwo) => {
            cellDataNum = two.cellData!.length;
            if (two.fieldlevelThree!.length === 0) {
                two.cellDataNum! = cellDataNum;
            }
            two.fieldlevelThree!.forEach((three: FieldlevelThree) => {
                cellDataNum = three.cellData!.length;
                three.cellDataNum! = cellDataNum;
            });
        });
    });
    return skillMapFieldTree;
};
export default getSkillMapFieldTree;
